/* eslint-disable no-undef */
export interface FormData {
  cod: string;
  title: string;
  id: string;
}

const getStoredData = (): FormData[] => {
  const storedData = localStorage.getItem('formDataArray');
  return storedData ? JSON.parse(storedData) : [];
};

const formDataArray: FormData[] = getStoredData();

export const addFormData = (newData: FormData) => {
  formDataArray.push(newData);
  localStorage.setItem('formDataArray', JSON.stringify(formDataArray));
  console.log('Dados adicionados:', newData);
  console.log('Todos os dados:', formDataArray);
};

export const getFormData = () => {
  return formDataArray;
};
